/**
 * Búsqueda del contrato de grilla: «contiene» sin mayúsculas ni tildes. Se normalizan el valor y lo
 * buscado (NFD, sin marcas U+0300–U+036F, minúsculas), igual que la API: aquí «muñoz» encuentra
 * «Munoz» (la ñ pierde su tilde), a diferencia de la búsqueda de `sc-select` (text.ts).
 */

/** «Ñandú» → «nandu». */
export function normalizeText(text: unknown): string {
  return String(text)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

/** Lo buscado, recortado y normalizado; `''` es «sin búsqueda». */
export function normalizeNeedle(text: unknown): string {
  return normalizeText(String(text ?? '').trim());
}

/** ¿El valor es texto y contiene lo buscado (ya normalizado)? */
export function textContains(value: unknown, needle: string): boolean {
  return typeof value === 'string' && normalizeText(value).includes(needle);
}
